/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore
import Header from './header/index.js';
// @ts-ignore
function View(props) {
    // @ts-ignore
    return React.createElement(Header, { ...props });
}
export default View;
